/**
 * @sw-package innovation
 *
 * @experimental stableVersion:v6.8.0 feature:SpatialCmsElement
 */

declare var window: StorefrontWindow;

const PluginManager = window.PluginManager;

PluginManager.register('SpatialCmsViewer', () => import ('./plugin/spatial/spatial-cms-viewer.plugin'), '[data-spatial-cms-viewer]');
